<template>
  <div>
    <ibox>
      <template slot="title" v-if="params.is_public!=0">口コミ一覧(公開中)</template>
      <template slot="title" v-if="params.is_public==0">口コミ一覧(公開前)</template>
      <template slot="tools">
        <!--<button class="btn btn-info btn-outline btn-xs btn-bitbucket" v-on:click="memberDownload">-->
        <!--<i class="fa fa-download"></i> Download-->
        <!--</button>-->
      </template>
      <template slot="body">
        <div class="row">
          <div class="col-lg-12">
            <company-review-search
              :params.sync="params"
              @clickSearch="clickSearch"></company-review-search>
            <div class="form-group">
              <div class=" col-sm-12">
                <table class="table table-hover">
                  <thead>
                  <tr>
                    <th>口コミ投稿ID</th>
                    <th>投稿日時</th>
                    <th>企業名</th>
                    <th>タイトル</th>
                    <th>公開/非公開</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>

                  <template v-for="(review,index) in reviews">
                    <company-review-list-row
                      :review="review"></company-review-list-row>
                  </template>
                  </tbody>
                </table>
                <pager @click="clickPager" v-bind:pager="pager"></pager>
              </div>
            </div>
            <line-dashed/>
          </div>
        </div>
      </template>
    </ibox>
  </div>
</template>

<script>
  import Api from '../../../service/Api.vue'
  import CompanyReviewSearch from '../../../components/company/review/Search.vue'

  export default {
    data () {
      return {
        params: {},
        reviews: [],
        pager: false,
        isModal: false,
        delete_member: []
      }
    },
    watch: {
      $route: {
        deep: true,
        handler: function () {
          this.init()
          this.reviews = []

          Api.review.search(this.params).then(this.searchSuccess)
        }
      }
    },
    created: function () {
      this.init()
      Api.review.search(this.params).then(this.searchSuccess)
    },
    methods: {
      init: function () {
        this.params = {}
        this.params.page = this.$route.query.page || 1
        this.params.is_public = this.$route.query.is_public || 0
        this.params.keyword = this.$route.query.keyword || ''
        this.params.member_id = this.$route.query.member_id || ''
        // this.reviewSearch()
      },
      clickSearch: function () {
        this.params.page = 1
        this.params.member_id = ''

        this.reviewSearch()
      },
      clickPager: function (page) {
        this.params.page = page
        this.reviewSearch()
      },
      reviewSearch: function () {
        let data = this.params
        data.order = 'review_id'
        data.sort = 'DESC'
        this.$router.push({
          path: '/company/review',
          query: data
        })
      },
      searchSuccess: function (response) {
        this.reviews = response.data.reviews
        this.pager = response.data.pager
        this.$nextTick(function () {
        })
      }
    },
    components: {
      CompanyReviewSearch
    }
  }
</script>



// WEBPACK FOOTER //
// List.vue?7f117056